import PubSub from "underpub-js";

var ListingCommunitiesSection = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-ListingCommunitiesSection',
	};

	$.extend(true, this.options, options);

};

ListingCommunitiesSection.prototype.init = function() {

	var self = this;

};

export default ListingCommunitiesSection;
